import {
  styled,
  Box as MuiBox,
  Stack as MuiStack,
  Typography as MuiTypography,
  typographyClasses,
} from "@mui/material";

export const Box = styled(MuiBox)(
  ({ theme }) => `
  &.image-editor-wrapper {
    position: relative;
    width: 100%;
    height: 100%;

    .coating {
      width: 100%;
      height: 100%;
      background: red;
      opacity:0;
      position: absolute;
      z-index: 10000;
    }
  }

  &.title-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.customer-info {
    font-size: 13px;
    font-weight: 400;
    line-height: 18.82px;
    text-align: center;
    padding: 0 10px;
    color: ${theme.palette.grey["700"]};
  }

  &.file-count {
    font-size: 15px;
    display: inline-flex;
    align-items: center;
    margin-left: 8px;
  }

`
);

export const Stack = styled(MuiStack)(
  () => `
  &.file-edit-page-title {
    width: 100%;
  }
  
`
);

export const Typography = styled(MuiTypography)(
  ({ theme }) => `
  &.${typographyClasses.h6} {
    max-width: calc(100vw - 250px);
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    white-space: nowrap;
    color: ${theme.palette.grey["700"]};
    font-size: 15px;
    line-height: 21.72px;

    &.customer {
      max-width: calc(100vw - 444px);
    }
  }
`
);
